/* eslint-disable @typescript-eslint/no-unused-vars */
import { View, Text as PDFText } from '@react-pdf/renderer'

import { Policies } from '../../../../../types/bookingDetails'
import styles from './styles/index.styles'

interface ModifyTermsAndConditionsProps {
  modifyPolicies: Policies[]
  modifyPolicyDescription: string[]
  splitTextByWords(inputString: string, maxLength: number): string[]
}

export const ModifyTermsAndConditions = ({
  modifyPolicies,
  modifyPolicyDescription,
  splitTextByWords
}: ModifyTermsAndConditionsProps) => {
  const somethingToShow = modifyPolicies.some((ele) => ele.deadline <= 4320)

  if (somethingToShow || modifyPolicyDescription.length > 0) {
    return (
      <View style={styles.mainDiv} wrap>
        <View style={styles.titleContainer}>
          <PDFText style={styles.subtitle}>Modify Terms & Conditions</PDFText>
        </View>
        <View style={styles.content}>
          {modifyPolicyDescription.length > 0
            ? modifyPolicyDescription.map((item) => {
                // const segments = splitTextByWords(item, 130)
                // return segments.map((segment, segIndex) => (
                //   <View
                //     key={segIndex}
                //     style={
                //       segIndex === 0
                //         ? styles.singleParagraph
                //         : styles.singleParagraphShort
                //     }>
                //     <View style={styles.title}>
                //       <PDFText>{segment}</PDFText>
                //     </View>
                //   </View>
                // ))
                return (
                  <View style={styles.title}>
                    <PDFText>{item}</PDFText>
                  </View>
                )
              })
            : modifyPolicies?.map((item, index) => {
                switch (item.policyType) {
                  case 'ReservationTime':
                    if (item.deadline > 4320) {
                      return (
                        <View
                          key={
                            item.policyType + index.toString() + item.deadline
                          }></View>
                      )
                    }
                    return (
                      <View
                        key={item.policyType + index.toString() + item.deadline}
                        style={styles.singleParagraph}>
                        <PDFText style={styles.title}>
                          {` ${
                            item.deadline % 24 === 0
                              ? Math.floor(item.deadline / 24)
                              : item.deadline
                          } `}
                          {`${
                            item.deadline % 24 === 0 && item.deadline / 24 !== 1
                              ? 'days'
                              : ''
                          }`}
                          {`${
                            item.deadline % 24 === 0 && item.deadline / 24 === 1
                              ? 'day'
                              : ''
                          }`}
                          {`${
                            item.deadline % 24 !== 0 && item.deadline !== 1
                              ? 'hours'
                              : ''
                          }`}
                          {`${item.deadline === 1 ? 'hour' : ''}`} after
                          reservation time:{' '}
                        </PDFText>
                        <PDFText style={styles.description}>
                          {item.penaltyAmount}% of the{' '}
                          {item.penaltyType === 'FirstNight'
                            ? 'first night price '
                            : 'total price '}
                          will be charged.
                        </PDFText>
                      </View>
                    )
                  case 'CheckInTime':
                    if (item.deadline > 4320) {
                      return (
                        <View
                          key={
                            item.policyType + index.toString() + item.deadline
                          }></View>
                      )
                    }
                    return (
                      <View
                        key={item.policyType + index.toString() + item.deadline}
                        style={styles.singleParagraph}>
                        <PDFText style={styles.title}>
                          Less than
                          {` ${
                            item.deadline % 24 === 0
                              ? Math.floor(item.deadline / 24)
                              : item.deadline
                          } `}
                          {`${
                            item.deadline % 24 === 0 && item.deadline / 24 !== 1
                              ? 'days'
                              : ''
                          }`}
                          {`${
                            item.deadline % 24 === 0 && item.deadline / 24 === 1
                              ? 'day'
                              : ''
                          }`}
                          {`${
                            item.deadline % 24 !== 0 && item.deadline !== 1
                              ? 'hours'
                              : ''
                          }`}
                          {`${item.deadline === 1 ? 'hour' : ''}`} before the
                          arrival time:{' '}
                        </PDFText>
                        <PDFText style={styles.description}>
                          {item.penaltyAmount}% of the{' '}
                          {item.penaltyType === 'FirstNight'
                            ? 'first night price '
                            : 'total price '}
                          will be charged.
                        </PDFText>
                      </View>
                    )
                  case 'AfterCheckInTime':
                    if (item.deadline > 4320) {
                      return (
                        <View
                          key={
                            item.policyType + index.toString() + item.deadline
                          }></View>
                      )
                    }
                    return (
                      <View
                        key={item.policyType + index.toString() + item.deadline}
                        style={styles.singleParagraph}>
                        <PDFText style={styles.title}>
                          Less than
                          {`${
                            item.deadline % 24 === 0
                              ? Math.floor(item.deadline / 24)
                              : item.deadline
                          }`}
                          {`${
                            item.deadline % 24 === 0 && item.deadline / 24 !== 1
                              ? 'days'
                              : ''
                          }`}
                          {`${
                            item.deadline % 24 === 0 && item.deadline / 24 === 1
                              ? 'day'
                              : ''
                          }`}
                          {`${
                            item.deadline % 24 !== 0 && item.deadline !== 1
                              ? 'hours'
                              : ''
                          }`}
                          {`${item.deadline === 1 ? 'hour' : ''}`} after
                          check-in time:{' '}
                        </PDFText>
                        <PDFText style={styles.description}>
                          {item.penaltyAmount}% of the{' '}
                          {item.penaltyType === 'FirstNight'
                            ? 'first night price'
                            : 'total price'}{' '}
                          will be charged.
                        </PDFText>
                      </View>
                    )
                  case 'BeforeCheckOutTime':
                    if (item.deadline > 4320) {
                      return (
                        <View
                          key={
                            item.policyType + index.toString() + item.deadline
                          }></View>
                      )
                    }
                    return (
                      <View
                        key={item.policyType + index.toString() + item.deadline}
                        style={styles.singleParagraph}>
                        <PDFText style={styles.title}>
                          Less than
                          {` ${
                            item.deadline % 24 === 0
                              ? Math.floor(item.deadline / 24)
                              : item.deadline
                          } `}
                          {`${
                            item.deadline % 24 === 0 && item.deadline / 24 !== 1
                              ? 'days'
                              : ''
                          }`}
                          {`${
                            item.deadline % 24 === 0 && item.deadline / 24 === 1
                              ? 'day'
                              : ''
                          }`}
                          {`${
                            item.deadline % 24 !== 0 && item.deadline !== 1
                              ? 'hours'
                              : ''
                          }`}
                          {`${item.deadline === 1 ? 'hour' : ''}`} before
                          checkout time:{' '}
                        </PDFText>
                        <PDFText style={styles.description}>
                          {item.penaltyAmount}% of the{' '}
                          {item.penaltyType === 'FirstNight'
                            ? 'first night price'
                            : 'total price'}{' '}
                          will be charged.
                        </PDFText>
                      </View>
                    )
                  default:
                    return <View></View>
                }
              })}
        </View>
      </View>
    )
  }
  return <View />
}
